import axios from 'axios'

export const baseAxios = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL
})

